document.addEventListener('click', event => {
 const trigger = event.target.closest('.vad-size-trigger');
 if (!trigger) return;
 const card = document.querySelector('main .vad-fit-card');
 if (!card) return;
 event.preventDefault();
 event.stopImmediatePropagation();
 card.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start'});
 card.focus({preventScroll:true});
}, true);

(() => {
 let busy = false;
 let cartSnapshot = null;
 let cartVerified = false;
 let cartRequest = null;
 let scheduled = false;
 const pendingVariants = new Set();
 const pendingCartUpdates = new Set();
 let eventsReady = false;
 const configurations = new WeakMap();
 const text = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
 const calculateOfferCart = (items, pools) => {
  const lines = items.map((item, index) => ({
   ...item, index,
   price: Math.max(0, Number(item.price) || 0),
   quantity: Math.max(0, Math.floor(Number(item.quantity) || 0)),
   rate: [10, 20].find(rate => (pools[String(rate)] || []).some(id => String(id) === String(item.product_id))) || 0,
   saving: 0, percent: 0
  }));
  const quantity = lines.reduce((sum, line) => sum + line.quantity, 0);
  for (const rate of [10, 20]) {
   if (quantity < (rate === 10 ? 2 : 3)) continue;
   const winner = lines.filter(line => line.quantity > 0 && line.rate === rate)
    .sort((a, b) => b.price - a.price || a.index - b.index)[0];
   if (!winner) continue;
   winner.saving = Math.round(winner.price * rate / 100);
   winner.percent = rate;
  }
  const progressiveSaving = lines.reduce((sum, line) => sum + line.saving, 0);
  let bestDuo = null;
  for (const duo of pools.duos || []) {
   if (!lines.some(line => line.quantity > 0 && duo.buys.includes(String(line.product_id)))) continue;
   const winner = lines.filter(line => line.quantity > 0 && duo.gets.includes(String(line.product_id)))
    .sort((a, b) => a.price - b.price || a.index - b.index)[0];
   if (!winner) continue;
   const saving = Math.floor(winner.price * 10 / 100);
   if (!bestDuo || saving > bestDuo.saving) bestDuo = { winner, saving };
  }
  if (bestDuo && bestDuo.saving > progressiveSaving) {
   lines.forEach(line => { line.saving = 0; line.percent = 0; });
   bestDuo.winner.saving = bestDuo.saving;
   bestDuo.winner.percent = 10;
  }
  const original = lines.reduce((sum, line) => sum + line.price * line.quantity, 0);
  const saving = lines.reduce((sum, line) => sum + line.saving, 0);
  lines.forEach(line => { line.discounted = line.price - line.saving; line.total = line.price * line.quantity - line.saving; });
  return { lines, quantity, original, saving, total: original - saving };
 };
 const config = form => {
  if (!configurations.has(form)) {
   configurations.set(form, {
    pools: JSON.parse(form.querySelector('[data-set-pools]')?.textContent || '{}'),
    initial: JSON.parse(form.querySelector('[data-set-cart]')?.textContent || '[]')
   });
  }
  return configurations.get(form);
 };
 const cartLines = (cart, form) => (cart?.items || config(form).initial).map(item => ({
  id: String(item.variant_id || item.id), product_id: String(item.product_id),
  price: Number(item.original_price ?? item.price), quantity: Number(item.quantity), key: item.key
 }));
 const hasCompetingDiscount = cart => (cart?.discount_codes || []).some(code => code.applicable)
  || (cart?.cart_level_discount_applications || []).length > 0
  || (cart?.items || []).some(item => (item.line_level_discount_allocations || []).some(allocation => !['Pack Vadrouk — premier accessoire −10 %', 'Pack Vadrouk — complément −20 %', 'Duo balade — 10 % sur un accessoire', 'Duo voiture — 10 % sur la grille'].includes(allocation.discount_application?.title))); 
 const selection = (form, cart = cartSnapshot) => {
  const existing = cartLines(cart, form);
  const lines = existing.map(line => ({ ...line }));
  const additions = [];
  const cartContext = form.dataset.cartContext === 'true';
  let main = null, variant = null, mainItem = null, missingOption = false;
  if (!cartContext) {
   main = document.querySelector('product-form-component[data-product-id="' + form.dataset.source + '"] form');
   variant = main?.querySelector('[name="id"]');
   const id = String(variant?.value || form.dataset.sourceVariant);
   const prices = JSON.parse(form.dataset.sourcePrices || '{}');
   const quantityInput = main?.closest('product-form-component')?.querySelector('[name="quantity"]');
   const quantity = Math.max(1, Math.floor(Number(quantityInput?.value) || 1));
   mainItem = { id, product_id: String(form.dataset.source), price: Number(prices[id]), quantity, main: true };
   let existingQuantity = 0;
   lines.forEach(line => {
    if (line.id !== id) return;
    line.main = true;
    existingQuantity += line.quantity;
   });
   if (quantity > existingQuantity) {
    const addedMain = { ...mainItem, quantity: quantity - existingQuantity };
    lines.push(addedMain);
    additions.push(addedMain);
   }
  }
  let chosenCount = 0;
  form.querySelectorAll('[data-set-item]').forEach(card => {
   const checkbox = card.querySelector('[data-set-select]');
   checkbox.disabled = busy;
   const chosen = checkbox.checked;
   const select = card.querySelector('[data-set-variant]');
   if (select) { select.disabled = !chosen || busy; select.required = chosen; }
   card.toggleAttribute('data-selected', chosen);
   if (!chosen) return;
   chosenCount++;
   const option = select?.selectedOptions[0];
   const id = select ? option?.value : card.dataset.defaultId;
   if (!id) missingOption = true;
   const item = { id, product_id: String(card.dataset.product), price: Number(option?.dataset.price || card.dataset.defaultPrice), quantity: 1, card };
   lines.push(item);
   additions.push(item);
  });
  return { existing, lines, additions, main, variant, mainItem, chosenCount, missingOption, cartContext };
 };
 const refreshSet = form => {
  const selected = selection(form);
  const model = calculateOfferCart(selected.lines, config(form).pools);
  const before = calculateOfferCart(selected.existing, config(form).pools);
  const otherDiscount = hasCompetingDiscount(cartSnapshot);
  const estimateReady = cartVerified && !otherDiscount && pendingVariants.size === 0 && pendingCartUpdates.size === 0;
  const money = value => new Intl.NumberFormat(form.dataset.locale || 'fr', { style: 'currency', currency: form.dataset.currency || 'EUR' }).format(value / 100);
  const showLine = (container, prefix, item) => {
   if (!container || !item) return;
   const saving = estimateReady ? item.saving : 0;
   text(container.querySelector('[data-set-' + prefix + 'price]'), money(item.price - saving));
   const original = container.querySelector('[data-set-' + prefix + 'original]');
   const tier = container.querySelector('[data-set-' + prefix + 'tier]');
   text(original, money(item.price));
   if (original) original.hidden = !saving;
   text(tier, (form.dataset.tier || '').replace('__PERCENT__', item.percent));
   if (tier) tier.hidden = !saving;
  };
  const mainLine = model.lines.find(line => line.main && line.saving) || model.lines.find(line => line.main);
  showLine(form.querySelector('[data-set-main]'), 'main-', mainLine);
  form.querySelectorAll('[data-set-item]').forEach(card => {
   const line = model.lines.find(item => item.card === card);
   const option = card.querySelector('[data-set-variant]')?.selectedOptions[0];
   showLine(card, '', line || { price: Number(option?.dataset.price || card.dataset.defaultPrice), saving: 0, percent: 0 });
  });
  text(form.querySelector('[data-set-total]'), estimateReady ? money(model.total) : form.dataset.pending || '');
  const extraSaving = Math.max(0, model.saving - before.saving);
  const savingNode = form.querySelector('[data-set-saving]');
  text(savingNode, (form.dataset.save || '').replace('__AMOUNT__', money(extraSaving)));
  if (savingNode) savingNode.hidden = !estimateReady || extraSaving === 0;
  const discountNote = form.querySelector('[data-set-discount-note]');
  if (discountNote) discountNote.hidden = !otherDiscount;
  const progress = form.querySelector('[data-set-cart-progress]');
  if (progress) text(progress, model.quantity < 2 ? progress.dataset.one : model.quantity < 3 ? progress.dataset.two : progress.dataset.ready);
  const button = form.querySelector('button[type="submit"]');
  button.hidden = false;
  button.disabled = busy || !eventsReady || !cartVerified || pendingVariants.size > 0 || pendingCartUpdates.size > 0 || selected.chosenCount === 0 || selected.missingOption
   || (!selected.cartContext && (!selected.variant || selected.variant.disabled || !Number.isFinite(selected.mainItem?.price) || selected.main?.querySelector('[type="submit"]')?.disabled));
 };
 const enable = () => {
  let newForm = false;
  document.querySelectorAll('.cro-set:not([data-completed])').forEach(form => {
   if (!configurations.has(form)) newForm = true;
   refreshSet(form);
  });
  if (newForm && !cartVerified && !cartRequest) requestAnimationFrame(synchronizeCart);
 };
 const schedule = () => {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => { scheduled = false; enable(); });
 };
 const request = async (form, path, body) => {
  const root = form.dataset.root.replace(/\/?$/, '/');
  const response = await fetch(root + path, {
   method: body ? 'POST' : 'GET',
   headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
   ...(body ? { body: JSON.stringify(body) } : {}), cache: 'no-store'
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.description || form.dataset.error);
  return data;
 };
 const fetchCart = async form => {
  if (!cartRequest) {
   cartRequest = request(form, 'cart.js').then(cart => { cartSnapshot = cart; cartVerified = true; return cart; })
    .finally(() => { cartRequest = null; schedule(); });
  }
  return cartRequest;
 };
 const synchronizeCart = () => {
  const form = document.querySelector('.cro-set');
  if (!form) return;
  cartVerified = false;
  enable();
  Promise.resolve(cartRequest).catch(() => {}).then(() => { cartVerified = false; return fetchCart(form); })
   .catch(() => { text(form.querySelector('[role="status"]'), form.dataset.error); });
 };
 enable();
 document.addEventListener('shopify:section:load', synchronizeCart);
 document.addEventListener('change', schedule);
 document.addEventListener('input', schedule);
 document.addEventListener('variant:update', schedule);
 document.addEventListener('quantity-selector:update', schedule);
 document.addEventListener('cart-section:restored', synchronizeCart);
 window.addEventListener('pageshow', event => { if (event.persisted) synchronizeCart(); });
 new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
 import('@shopify/events').then(({ StandardEvents }) => {
  document.addEventListener(StandardEvents.productSelect, event => {
   const token = {};
   pendingVariants.add(token);
   enable();
   Promise.resolve(event.promise).catch(() => {}).finally(() => {
    requestAnimationFrame(() => { pendingVariants.delete(token); schedule(); });
   });
  }, true);
  document.addEventListener(StandardEvents.cartLinesUpdate, event => {
   const token = {};
   pendingCartUpdates.add(token);
   cartVerified = false;
   enable();
   Promise.resolve(event.promise).catch(() => {}).finally(() => {
    pendingCartUpdates.delete(token);
    synchronizeCart();
   });
  }, true);
  eventsReady = true;
  schedule();
 }).catch(() => {
  document.querySelectorAll('.cro-set').forEach(form => text(form.querySelector('[role="status"]'), form.dataset.error));
 });
 document.addEventListener('submit', async event => {
  const form = event.target.closest('.cro-set');
  if (!form) return;
  event.preventDefault();
  if (busy || !eventsReady || pendingVariants.size > 0 || pendingCartUpdates.size > 0 || form.dataset.completed) return;
  const status = form.querySelector('[role="status"]');
  const button = form.querySelector('button[type="submit"]');
  const initial = selection(form);
  if (initial.chosenCount === 0) { text(status, form.dataset.pick); return; }
  if (initial.missingOption || !form.reportValidity()) { text(status, form.dataset.options); return; }
  if (!initial.cartContext && (!initial.variant || initial.variant.disabled || !Number.isFinite(initial.mainItem?.price) || initial.main?.querySelector('[type="submit"]')?.disabled)) { text(status, form.dataset.missing || form.dataset.error); return; }
  const label = button.textContent;
  busy = true;
  enable();
  text(button, form.dataset.busy);
  text(status, '');
  let added = false;
  try {
   const cart = await fetchCart(form);
   if (pendingVariants.size > 0 || pendingCartUpdates.size > 0) throw new Error(form.dataset.options);
   const current = selection(form, cart);
   if (current.missingOption || current.chosenCount === 0) throw new Error(form.dataset.options);
   if (!current.cartContext && (!current.variant || current.variant.disabled || !Number.isFinite(current.mainItem?.price) || current.main?.querySelector('[type="submit"]')?.disabled)) throw new Error(form.dataset.missing || form.dataset.error);
   const items = current.additions.map(item => ({ id: Number(item.id), quantity: item.quantity }));
   await request(form, 'cart/add.js', { items });
   added = true;
   form.dataset.completed = 'true';
   await fetchCart(form);
   window.location.assign(form.dataset.cart);
  } catch (error) {
   text(status, added ? form.dataset.added : error.message || form.dataset.error);
   const link = document.createElement('a');
   link.href = form.dataset.cart;
   link.textContent = ' →';
   link.setAttribute('aria-label', form.dataset.pending || form.dataset.added);
   status.append(link);
  } finally {
   busy = false;
   text(button, label);
   if (added) button.hidden = true;
   enable();
  }
 });
})();


(() => {
 const connect = () => {
  const link = document.querySelector('main .vad-quick-choice');
  const form = document.querySelector('main product-form-component form');
  if (!link || !form || link.dataset.ready) return;
  link.dataset.ready = 'true';
  const update = () => { link.hidden = !matchMedia('(max-width: 749px)').matches || form.getBoundingClientRect().top < innerHeight; };
  const observer = new IntersectionObserver(update);
  observer.observe(form);
  window.addEventListener('resize', update, { passive: true });
  link.addEventListener('click', event => {
   event.preventDefault();
   const target = document.querySelector('main variant-picker') || form;
   target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
   const control = target.querySelector('input:not([disabled]),button:not([disabled]),select:not([disabled])');
   control?.focus({ preventScroll: true });
  });
  update();
 };
 connect();
 document.addEventListener('shopify:section:load', connect);
})();
